import { LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { programLabels } from '@/config';
import { getManufacturerByProgram } from '@/libs/util';
import useGlobalConfig from '@/store/global';

import AlygloSupport from './alyglo';
import CoagadexSupport from './coagadex';
import CutaquigSupport from './cutaquig';
import FibrygaSupport from './fibryga';
import GammakedSupport from './gammaked';
import GammaplexSupport from './gammaplex';
import GamunexSupport from './gamunex';
import KoateSupport from './koate';
import NuwiqSupport from './nuwiq';
import OctagamSupport from './octagam';
import PanzygaSupport from './panzyga';
import RyplazimSupport from './ryplazim';
import WilateSupport from './wilate';

const PatientSupport = () => {
  const { program, themeColor } = useGlobalConfig();
  const name = program.name;
  const medicalProgram = [
    'alyglo',
    'coagadex',
    'gammaked',
    'gammaplex',
    'gamunex',
    'koate',
    'ryplazim',
    'cutaquig',
    'octagam',
    'panzyga',
    'fibryga',
    'nuwiq',
    'wilate',
  ];

  const MedicalContent = () => {
    switch (name) {
      case 'alyglo':
        return <AlygloSupport themeColor={themeColor} />;
      case 'coagadex':
        return <CoagadexSupport themeColor={themeColor} />;
      case 'gammaked':
        return <GammakedSupport themeColor={themeColor} />;
      case 'gammaplex':
        return <GammaplexSupport themeColor={themeColor} />;
      case 'gamunex':
        return <GamunexSupport themeColor={themeColor} />;
      case 'koate':
        return <KoateSupport themeColor={themeColor} />;
      case 'ryplazim':
        return <RyplazimSupport themeColor={themeColor} />;
      case 'cutaquig':
        return <CutaquigSupport themeColor={themeColor} />;
      case 'octagam':
        return <OctagamSupport themeColor={themeColor} />;
      case 'panzyga':
        return <PanzygaSupport themeColor={themeColor} />;
      case 'fibryga':
        return <FibrygaSupport themeColor={themeColor} />;
      case 'nuwiq':
        return <NuwiqSupport themeColor={themeColor} />;
      case 'wilate':
        return <WilateSupport themeColor={themeColor} />;
      default:
        return null;
    }
  };

  if (medicalProgram.includes(name)) {
    return (
      <div className="text-base">
        <MedicalContent />

        <div>
          <Button
            type="primary"
            icon={<UserOutlined />}
            size="large"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => (window.location.href = '/signup')}
          >
            Provider Registration
          </Button>
          <Button
            type="primary"
            icon={<LoginOutlined />}
            size="large"
            className="ml-10"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => (window.location.href = '/signin')}
          >
            Provider Login
          </Button>
        </div>
        <div className="my-10">
          This program is subject to change or discontinuation by&nbsp;
          <b>{getManufacturerByProgram(name)}</b>
          &nbsp;at any time, for any reason, and with or without prior notice. This portal is
          administered by&nbsp;
          <a target="_blank" href="https://medmonk.com/" className="text-blue-500 hover:underline">
            Medmonk
          </a>
          &nbsp;for the {programLabels[name].label} Program.
        </div>
      </div>
    );
  }

  return null;
};

export default PatientSupport;
